import type { PillProps } from '@/shared/components';
import { ROLE_LABELS_DE, ROLES, type Role } from '@/shared/auth';
import type { UserResponse, UserStatusFilter } from '@/shared/api';

/**
 * Die eine Ableitung des Kontozustands — sie beschriftet die Statuspille **und** entscheidet,
 * was der gleichnamige Serverfilter meint (`UserStatusFilter` in der Identity-Contracts).
 *
 * <p>Deaktiviert gewinnt gegen eingeladen. Ein Konto, das gesperrt wurde, bevor die Einladung
 * angenommen war, als „Eingeladen" zu zeigen, hieße: wir warten auf jemanden. Wir warten nicht,
 * wir haben zugesperrt.</p>
 */
export function userStatus(u: UserResponse): UserStatusFilter {
  if (!u.isActive) return 'Inactive';
  return u.emailConfirmed ? 'Active' : 'Invited';
}

export const USER_STATUS_LABELS: Record<UserStatusFilter, string> = {
  Active: 'Aktiv',
  Inactive: 'Deaktiviert',
  Invited: 'Eingeladen',
};

/** Farbe nie ohne Text (§11) — die Pille trägt beides. */
export const USER_STATUS_PILL: Record<UserStatusFilter, NonNullable<PillProps['variant']>> = {
  Active: 'live',
  Inactive: 'outline',
  Invited: 'warning',
};

/**
 * PlatformAdmin steht als zusätzliche Rolle neben der fachlichen — für die Anzeige zählt die
 * fachliche Rolle, weil sie den Zugriff im Workspace beschreibt.
 */
export const userRole = (u: UserResponse): string =>
  u.roles.find((role) => role !== ROLES.PlatformAdmin) ?? u.roles[0] ?? '';

export const roleLabel = (role: string): string => ROLE_LABELS_DE[role as Role] ?? role;

export const fullName = (u: UserResponse): string =>
  `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim() || u.email;
